import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'

import bg1 from '../assets/images/hero/bg1.jpg'
import bg2 from '../assets/images/hero/bg2.jpg'
import bg3 from '../assets/images/hero/bg3.jpg'

export default function HomeBannner() {

    const images = [
        bg1,
        bg2,
        bg3,
      ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0); 
    
    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => 
            (prevIndex + 1) % images.length 
          );
        }, 5000);
    
        return () => clearInterval(interval);
      }, [images.length]);

  return (
    <section className="d-flex align-items-center bg-finance" id="home" style={{backgroundImage:`url(${images[currentImageIndex]})`}}>
        <div className="container position-relative z-1">
            <div className="row">
                <div className="col-md-6 background">
                    <div className="title-heading pe-lg-5 pe-md-4">
                        <span className="badge bg-primary mb-2">Finbie Finance</span>
                        <h1 className="heading fw-semibold text-capitalize mb-3">Maximize your <br/> <span className="border-animation position-relative">income and build</span> lasting wealth.</h1>
                        <p className="para-desc text-muted mb-0">Ensuring secure transactions and seamless financial experiences for our users globally.</p>
                    
                        <div className="mt-4">
                            <Link to="" className="btn btn-primary me-1">Get Started <i className="mdi mdi-arrow-right"></i></Link>
                            <Link to="" className="btn btn-outline-primary">Learn More</Link>
                        </div>

                        <ul className="list-unstyled mt-3 text-muted mb-0">
                            <li className="list-inline-item me-4"><i className="mdi mdi-check text-primary me-2"></i>Hire experts</li>
                            <li className="list-inline-item me-4"><i className="mdi mdi-check text-primary me-2"></i>Avoid scams</li>
                            <li className="list-inline-item me-4"><i className="mdi mdi-check text-primary me-2"></i>Contingecy fees</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
